<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <!-- <div class="flex flex-col space-y-1.5 p-6"> -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Administración de Productos
    </h3>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Producto
    </button>
  </div>

  <div
    class="grow h-full flex items-start p-6 pt-0 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
  >
    <div class="h-full w-full">
      <table class="w-full">
        <thead>
          <tr class="border-b border-border">
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Producto
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              SKU
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Categorías
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Precio <br />Menudeo
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Precio <br />Mayoreo
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Precio <br />por Rollo
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Unidad <br />de Medida
            </th>
            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          @for(product of products; track product.id) {
          <tr class="border-b border-border hover:bg-accent transition-colors">
            <td class="py-4 px-4">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
                >
                  <ng-icon
                    name="lucidePackage"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </div>
                <div>
                  <!-- <p class="text-foreground font-medium">{{ category.name }}</p> -->
                  <p class="text-foreground font-medium text-sm">
                    {{ product.name }}
                  </p>
                  <p class="text-muted-foreground text-xs">
                    {{ product.description }}
                  </p>
                </div>
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-[0.65rem]">
              {{ product.sku }}
            </td>
            <td class="py-4 px-4 w-1/5">
              <div class="flex flex-row items-center flex-wrap gap-1">
                @for(category of product.product_categories; track category.id)
                {
                <span
                  class="px-2.5 py-0.5 rounded-full text-xs font-medium border text-nowrap text-[0.55rem]"
                >
                  <!-- inline-flex items-center -->
                  {{ category.name }}
                </span>
                }
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.price_retail | currency : "MXN" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.price_wholesale | currency : "MXN " }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.price_roll | currency : "MXN" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.uom }}
            </td>
            <td class="py-4 px-4 w-1/12">
              <div class="flex items-center space-x-1">
                <button
                  class="ghost sm text-muted-foreground hover:text-foreground"
                  type="button"
                  (click)="updateProduct(product)"
                >
                  <ng-icon
                    name="lucidePenLine"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>

                <button
                  class="ghost sm text-destructive"
                  type="button"
                  (click)="deleteProduct(product.id)"
                >
                  <ng-icon
                    name="lucideTrash2"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-product-form
  [(showModal)]="showModal"
  [existingProduct]="existingProduct"
></app-product-form>
